import ready, { HTML } from 'Utils';
import initMenu from './components/menu';
import initAccordion from './components/accordion';
import initCard from './components/card';
import initSwiper from './components/carousel';
import initCountUp from './components/countUp';
import initTopMsg from './components/topMsg';
import initPopup from './components/popup';
import initHeaderHideShow from './components/headerHideShow';
import initTabs from './components/tabs';
import initFB from './components/fancybox';
import initAnimation from './components/animation';
import initFSelect from './components/fselect';
import initMap from './components/map';

ready(() => {
  HTML.classList.add('is-loaded');
});

document.addEventListener(
  'DOMContentLoaded',
  () => {
    initMenu();
    initAccordion();
    initCard();
    initSwiper();
    initCountUp();
    initTopMsg();
    initPopup();
    initHeaderHideShow();
    initTabs();
    initFB();
    initAnimation();
    initFSelect();
    initMap();
  },
  false
);
